import React from 'react'
import Clock from '../icons/Clock'
import Tick from '../icons/Tick'
import { useDispatch } from 'react-redux'
import { ACCEPT_LESSON } from '../redux/lessonsReducer'
interface Props {
  name: string
  date: string
  lessonId: number
}

const LessonItemPending = ({ name, date, lessonId }: Props) => {
  const dispatch = useDispatch()
  return (
    <div className="flex-1 bg-grayBackground rounded-md flex justify-between items-center p-4">
      <div className="flex items-center gap-2">
        <div className="w-8 h-8 text-slateGray">
          <Clock />
        </div>
        <div className="text-18 font-sans text-black font-semibold">{name}</div>
      </div>
      <div className="text-18 font-sans text-black">{date}</div>
      <div className="text-18 font-sans text-black">
        <div
          onClick={() => dispatch(ACCEPT_LESSON({ lessonId }))}
          className="w-10 h-10 text-white bg-[#22C55E] rounded-full flex items-center justify-center p-2 cursor-pointer">
          <Tick />
        </div>
      </div>
    </div>
  )
}

export default LessonItemPending
